module.exports = __webpack_public_path__ + "static/media/chart-usgold.2f7792a0.jpg";